(function () {
  angular.module('leanlaw').directive('llLoader', loader);
  loader.$inject = [];
  function loader() {
    return {
      restrict: 'EA',
      scope: {
        hideText: '=',
        text: '@'
      },
      template: require("./views/ll-loader.html")
    };
  }
})();